import React from "react";
import { openModal } from "../../../Library/ModalPopUp"

const NotifAnnouncement = ({ data }) => {
    const BodyMsg = ({ data }) => {

        return (
            <div>
                <div className="text-right">
                    <button className="btn btn-icon btn-xs btn-hover-light-warning" onClick={() => openModal({ open: false })} type="button">
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                {data.map((v, index) => (
                    <div className="mb-5" key={index}>
                        <h3 className="mb-10">{v.Title}</h3>
                        <div style={{ overflow: "auto", minWidth: "200px" }}>
                            <div dangerouslySetInnerHTML={{ __html: v.Message }} />
                        </div>
                        <div className="separator separator-dashed mt-8 mb-5"></div>
                    </div>
                ))}
            </div>
        )
    }
    openModal({ message: <BodyMsg data={data} />, size: "lg" })

    return "";
}

export { NotifAnnouncement }